import { Option, OptGroup } from "rc-select";
import Select from "./Select";
import Language from "./Language";

const SelectClone: typeof Select & {
  Option: typeof Option;
  OptGroup: typeof OptGroup;
  Language: typeof Language;
} = Object.assign(Select, { Option, OptGroup, Language });

export default SelectClone;
